import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class BHFilter extends AdornisFilter {
  static override _class = 'BHFilter';

  constructor(doc: PartialEntityData<BHFilter>) {
    super(doc);
  }

  @Field(type => String) institutionID: Maybe<string>;
  @Field(type => String) productID: Maybe<string>;
  @Field(type => String) lecturerID: Maybe<string>;
  @Field(type => String) timeframeID: Maybe<string>;
  @Field(type => String) categoryID: Maybe<string>;
  @Field(type => String) userID: Maybe<string>;

  override getMongoFilter() {
    const filter = super.getMongoFilter();
    if (this.institutionID) filter.institutionID = this.institutionID;
    if (this.productID) filter.productID = this.productID;
    if (this.lecturerID) filter.lecturerID = this.lecturerID;
    if (this.timeframeID) filter.timeframeID = this.timeframeID;
    if (this.categoryID) filter.categoryID = this.categoryID;
    if (this.userID) filter.userID = this.userID;

    return filter;
  }
}
